import { render, staticRenderFns } from "./Loyalty.template.vue?vue&type=template&id=799f23d0&scoped=true&"
var script = {}
import style0 from "./Loyalty.template.vue?vue&type=style&index=0&id=799f23d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f23d0",
  null
  
)

export default component.exports